<!--新增证书设置  -->
<template>
<div>
<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="740px" 
        :before-close="handleClose" append-to-body>
    <el-col class="red mg-b-20" >注意：仅限添加在掼一把小程序注册过的学员</el-col>
    <el-form :model="ruleForm" :rules="rules" ref="formRef" label-width="80px">                
        <el-row>
            <el-col :span="12">
                <el-form-item label="学员姓名" prop="username">  
                    <el-autocomplete style="width: 100%;" :clearable="true"
                        v-model="ruleForm.username"
                        :fetch-suggestions="querySearch"
                        placeholder="请输入学员姓名"
                        :trigger-on-focus="false"
                        @select="handleSelect"
                        :disabled="editUsername"
                    ></el-autocomplete>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="手机号" prop="phone">  
                    <el-input v-model="ruleForm.phone" placeholder="手机号" readonly></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="证书类型" prop="certType">
                    <el-select v-model="ruleForm.certType" style="width: 100%;" @change="selectCert">
                        <el-option 
                            v-for="item in typeOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="证书等级" prop="certificateLevel">
                    <el-select v-model="ruleForm.certificateLevel" style="width: 100%;">
                        <el-option 
                            v-for="item in LevelOption"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-col>            
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="证书编号" prop="certificateNo">
                    <el-input type="text" v-model="ruleForm.certificateNo" maxlength="20"
                        placeholder="请输入证书编号">
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="身份证号" prop="identity">
                    <el-input type="text" v-model="ruleForm.identity" maxlength="18"
                    placeholder="请输入身份证号" @input="handleInputLimitId"></el-input>
                </el-form-item>
            </el-col>                
        </el-row>
        <el-row>
            <el-col :span="12">
                <el-form-item label="发证日期" prop="issueDate">
                    <el-date-picker
                        value-format="yyyy-MM-dd"
                        style="width: 100%;"
                        v-model="ruleForm.issueDate"
                        type="date"
                        @change="selectDate"
                        placeholder="选择日期">
                        </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="发证单位" prop="issueClub">
                    <el-input type="text" v-model="ruleForm.issueClub"
                        placeholder="请输入发证单位">
                    </el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>               
            <el-col :span="12">
            <el-form-item label="上传照片" prop="imageUrl" class="form" >
                <el-upload class="avatar-uploader" ref="coverPicUpload" action="" list-type="picture-card" accept="image/*"
                    multiple :limit="1" name="file" :show-file-list="false" :http-request="handleRequest" 
                    :before-upload="handleBeforeUpload" :on-error="handleUploadError">
                    <el-image v-if="!ruleForm.imageUrl" :src="ruleForm.imageUrl">
                    <div slot="error" class="image-slot">
                        <i class="el-icon-plus" />
                    </div>
                    </el-image>
                    <div v-else class="image">
                    <el-image :src="ruleForm.imageUrl" :style="`width:150px;height:150px;`" fit="fill" />
                    <div class="mask">
                        <div class="actions">
                        <span title="移除" @click.stop="handleRemove">
                            <i class="el-icon-delete" />
                        </span>
                        </div>
                    </div>
                    </div>
                </el-upload>
                <el-col class="red">注意：请上传2寸彩色登记照</el-col>
            </el-form-item>   
        </el-col>             
        </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="confirmDialog">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
export default {
    props:{
        publishId: {
            type: String,
            default: ''
        },
       
        title:{
            type: String,
            default: ''
        },
        formData: {
            type: Object,
            default:{}
        },
    },
    components:{
       
    },
    watch: {
        // visible(newVal) {
        //     this.dialogVisible = newVal;
        // },
        // dialogVisible(newVal) {
        //     this.$emit('update:visible', newVal);
        // },
        'ruleForm.username'(val){
            if(val === ''){
                this.ruleForm.userId = ''
                this.ruleForm.phone = ''
            }
        }, 
        'ruleForm.certType'(val){            
            if(val === '1'){
                this.LevelOption = this.LevelOption1
            }else if(val === '2'){
                this.LevelOption = this.LevelOption2
            }else if(val === '3'){
                this.LevelOption = this.LevelOption3
            }
        }      
    },
    data() {
        return {
            dialogTitle: '',            
            ruleForm: {
                index: '',
                userId: '',
                username: '',
                phone: '',
                certificateNo: '',
                certificateLevel: '',
                issueClub: '',
                issueDate: '',
                issueTime: '',
                identity: '',
                imageUrl: '',
                issueDateFormat: '', 
                issueTimeFormat: '',
                certType: ''
            },
            rules: {
                username:[
                    { required: true, message: '请输入学员姓名', trigger: 'blur' },
                ],
                phone:[
                    { required: true, message: '请输入有手机号的学员', trigger: 'blur' },
                ],
                identity: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' },
                ],
                certificateNo: [
                    { required: true, message: '请输入证书编号', trigger: 'blur' },
                ],
                certType: [
                    { required: true, message: '请选择证书类型', trigger: 'change' },
                ],
                certificateLevel: [
                    { required: true, message: '请输入证书等级', trigger: 'blur' },
                ],
                issueClub: [
                    { required: true, message: '请输入发证单位', trigger: 'blur' },
                ],
                issueDate: [
                    { required: true, message: '请选择发证日期', trigger: 'change' },
                ],
                // issueTime: [
                //     { required: true, message: '请选择发证时间', trigger: 'change' },
                // ],
                // imageUrl: [
                //     { required: true, message: '请上传2寸照片', trigger: 'change' },
                // ],
                // userId: [
                //     { required: true, message: '该学员还未注册！请先注册再发证', trigger: 'change' },
                // ]
            },
            disabled: false,
            editUsername: false,
            typeOption: [],
            LevelOption: [],
            LevelOption1: [
                {value:'初级', label:'初级'},
                {value:'中级', label:'中级'},
                {value:'高级', label:'高级'},
                {value:'王牌', label:'王牌'},
                {value:'金牌', label:'金牌'},
            ],   
            LevelOption2: [
                {value:'国家三级', label:'国家三级'},
                {value:'国家二级', label:'国家二级'},
                {value:'国家一级', label:'国家一级'},
                {value:'国家级', label:'国家级'},
                {value:'国际级', label:'国际级'},
                {value:'其它级别', label:'其它级别'},
            ], 
            LevelOption3: [
                {value:'国家三级', label:'国家三级'},
                {value:'国家二级', label:'国家二级'},
                {value:'国家一级', label:'国家一级'},
                {value:'国家级', label:'国家级'},
                {value:'国际级', label:'国际级'},
            ],               
            dialogVisible: true,           
        }
    },
    created() {
       this.dialogTitle = this.title        
       if(this.dialogTitle === '更新证书'){
            this.ruleForm = {...this.formData}
            this.ruleForm.issueDate = this.$help.formatDate(this.formData.issueDate) 
            this.ruleForm.issueDateFormat = this.formData.issueDate
       }  
    },
    mounted() {       
        this.getType()
    },
    methods: {
        getType(){            
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 107,
            }
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    let arr= res.Data.DataTable
                    this.typeOption = arr.map(item=>{
                        return{
                            label: item['中文描述'],
                            value: item['词条索引']
                        }
                    })
                }
            })
        },        
        confirmDialog() {
            this.$refs.formRef.validate((valid) => {
                if (valid) {
                    // 校验通过，传递表单数据到父组件
                    this.handleSubmit()    
                } else {
                    window.scrollTo({
                        top:0,
                        behavior: 'smooth'
                    })
                    console.log('表单校验失败');
                    return false;
                }
            });
        }, 
        handleSubmit(){
            let { username, userId, phone, certificateLevel,certificateNo, certType,
                    identity,  issueClub, issueDateFormat, imageUrl } = this.ruleForm
            let params = {
                opcode: this.$code.traineeSetting,
                v_student_name: username,
                v_phone: phone,
                i_student_no: userId,
                i_flag: 1,
                i_number: this.ruleForm.index,
                v_certificate_no: certificateNo,
                v_certificate_level: certificateLevel,
                v_issue_unit: issueClub,
                c_issue_date: issueDateFormat,
                c_issue_time: 0,
                v_identity_card: identity,
                v_identity_image: imageUrl,
                i_remark: certType
            }
            // console.log(params)
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){
                    this.disabled = true
                    if(this.dialogTitle==='更新证书'){
                        this.$message.success('更新证书成功')
                    }else{
                        this.$message.success('设置证书成功')
                    }    
                    this.$emit('confirm');
                    this.closeDialog();        
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        handleSelect(row){
            this.ruleForm.phone = row.phone
            this.ruleForm.userId = row.userId
            this.ruleForm.username = row.username  
        },
        async querySearch(queryString, cb){
            let result = queryString ? await this.getUserInfoSearch(queryString) : []  
            cb(result)
        },
        // 模糊搜索查询
        getUserInfoSearch(val){
            return new Promise((resolve,reject)=>{
                if(val.length > 1){
                    let params = {
                        opcode: this.$code.UserInfoSearch,
                        v_name: val,
                        v_caption: '',
                        v_phone: '',
                    }
                    // 查询信息
                    this.$api._requestAPI(params).then(res => {
                        if (res.IsSuccess) {
                            let result = res.Data.DataTable
                            if(result.length === 0){                               
                                this.ruleForm.userId = ''                                
                            }else{
                                let arr  = result.map(item=>{
                                    return{
                                        value:item['姓名'] +''+ item['手机号'],
                                        userId: item['会员账号'],
                                        username: item['姓名'],
                                        phone: item['手机号'],   
                                        role: item['角色']                                     
                                    }
                                })  
                                resolve(arr)                         
                            }
                    }
                    }).catch(err => { reject(err)})
                }else{
                    this.ruleForm.userId = ''   
                }
            })         
        }, 
        async handleRequest(file,fileList){
            let url = await this.$help.uploadRequest(file)
            this.ruleForm.imageUrl = this.$global.uploadUrl + url
            this.loading.close();
            this.$refs.coverPicUpload.clearFiles()
        },
        handleRemove(file, fileList) {
            this.ruleForm.imageUrl = ''
        },
        handleUploadError() {
            this.$message({
                type: "error",
                message: "上传失败",
            });
            this.loading.close();
        },
        handleBeforeUpload() {
            this.loading = this.$loading({
                lock: true,
                text: "上传中",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.loading.close();
        },
        selectDate(value){
            this.ruleForm.issueDateFormat  = value.replace(/-/g, '')
        },
        selectTime(value){
            this.ruleForm.issueTimeFormat  = value.replace(/:/g, '')
        },  
        selectCert(value){
            this.ruleForm.certificateLevel = ''
        },
        // 校验证书编号
        handleInputLimitCert(value){
            const pattern = /^[a-zA-Z0-9]+$/g
            if (pattern.test(value)) {
                // 双向绑定
                this.ruleForm.certificateNo = value
            } else {
            // 输入值不为正整数，则从中提取出数字并拼接为字符串
            const num = value.match(/\\d+/g)
                this.ruleForm.certificateNo = num ? num.join('') : ''
            }
        },
        // 校验身份证号
        handleInputLimitId(value){
            const pattern = /^[a-zA-Z0-9]+$/g
            if (pattern.test(value)) {
                // 双向绑定
                this.ruleForm.identity = value
            } else {
            // 输入值不为正整数，则从中提取出数字并拼接为字符串
            const num = value.match(/\\d+/g)
                this.ruleForm.identity = num ? num.join('') : ''
            }
        }, 
        closeDialog() {
            this.resetForm()
            this.$emit('close');
        },
        handleClose(){
            this.resetForm()
            this.$emit('close');
        },   
        resetForm(){
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            } else {
                console.error('表单组件未找到');
            }
        }
    }
}
</script>
<style lang='scss' scoped>
.image {
  position: relative;

  .mask {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: all 0.3s;
  }

  &:hover .mask {
    opacity: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/traineeManage/components/addTrainDialog.vue